import JournalVoucher from "./JournalVoucher";

export default JournalVoucher;